import { Link, useLocation } from "react-router-dom";
import { Home, Clock, Sparkles, Settings as SettingsIcon } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/wallet", label: "Home", icon: Home, match: ["/wallet", "/"] },
  { to: "/history", label: "Activity", icon: Clock, match: ["/history"] },
  { to: "/creator-mode", label: "Creator", icon: Sparkles, match: ["/creator-mode"] },
  { to: "/settings", label: "Settings", icon: SettingsIcon, match: ["/settings"] },
] as const;

export const BottomTabs = () => {
  const { pathname } = useLocation();
  return (
    <>
      <div className="h-20" />
      <nav
        aria-label="Primary"
        className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md bg-background/95 backdrop-blur border-t border-border z-40"
      >
        <ul className="grid grid-cols-4 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2">
          {TABS.map(({ to, label, icon: Icon, match }) => {
            const active = match.some((m) => (m === "/" ? pathname === "/" : pathname.startsWith(m)));
            return (
              <li key={to} className="flex">
                <Link
                  to={to}
                  className={cn(
                    "flex-1 flex flex-col items-center gap-0.5 py-1.5 text-[11px] font-medium transition-colors",
                    active ? "text-primary" : "text-muted-foreground hover:text-foreground"
                  )}
                  aria-current={active ? "page" : undefined}
                >
                  <Icon className={cn("h-5 w-5", active && "drop-shadow")} />
                  <span>{label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </>
  );
};
